<template lang="pug">
.cheatsheet-controls(v-if="!engage")
  lp-switcher.cheatsheet-preview(v-if="lp",
                                 v-model="lp",
                                 :options="lps",
                                 title="Open Cheatsheet in a new window",
                                 @input="swicthed")
  .share(@click="save()",
         :class="{ hidden: !hideSelect && !(sharing && hasCheatsheet), pressed: shareClicked === shareKey }",
         title="Sharing") share
  .select(v-if="!hideSelect",
          @click="sharing = !sharing",
          :class="{ on: sharing }",
          title="Toggle selection mode") select
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed, licensePlate } from '@/helpers';
import lpSwitcher from './lp-switcher';
export default {
  name: 'cheatsheetControl',
  props: {
    shareKey: {
      type: String,
      default: 'insights'
    },
    hideSelect: Boolean,
    hasCheatsheet: Boolean,
    payload: Object
  },
  computed: {
    // todo: remove 'filteredDocs', 'selectedDocuments' when beforeSave is implemented
    //...mapGetters(['lpServer']),
    ...mapGetters(['lpServer', 'filteredDocs', 'selectedDocuments', 'engage']),
    // todo: remove mapGetters('insightsNS' when beforeSave is implemented
    ...mapGetters('insightsNS', ['selectedInsights', 'insightsForCheatSheet']),
    ...vuexComputed('lp', 'lps', 'shareClicked', 'sharing', 'token'),
    selectedDocs() {
      const { filteredDocs, selectedDocuments } = this;
      console.log('selectedDocs', filteredDocs, selectedDocuments);
      return filteredDocs?.filter(({ pgn }) => selectedDocuments[pgn]) || [];
    }
  },
  components: { lpSwitcher },
  methods: {
    ...mapActions(['addLoader', 'removeLoader']),
    swicthed(value) {
      const { lps } = this;
      const has = lps.includes(value);
      if (!has) {
        lps.push(value);
        this.lps = lps;
      }
      console.log('swicthed', value, lps, lps.includes(value));
    },
    async save() {
      const {
        insightsForCheatSheet,
        $cookie,
        selectedDocs,
        lpServer,
        shareKey,
        addLoader,
        removeLoader,
        // $nextTick,
        payload: outerPayload = {}
      } = this;
      console.log('save', this.filteredDocs, this.selectedDocuments, selectedDocs);
      const pages = shareKey === 'pages';
      //let l = this.$cookie.get('lp') || licensePlate();
      this.shareClicked = shareKey;
      //nextTick(() => this.shareClicked = false);
      setTimeout(() => (this.shareClicked = false), 250);
      let l = this.lp || licensePlate();
      if (!/^c/.test(l)) {
        l = 'c' + l;
      }
      console.log('save', l);
      //const payload = {};
      const payload = { ...outerPayload };
      if (pages) {
        if (selectedDocs) {
          const dids = selectedDocs.reduce((all, { did }) => {
            all[did] = all[did] || [];
            return all;
          }, {});
          selectedDocs.forEach(({ did, pgn }) => dids[did].push(pgn));
          payload.pages = dids;
          //filteredDocuments.filter(({ pgn }) => selectedDocuments[pgn]).map(({ id }) => id)
        }
      }
      if (insightsForCheatSheet?.length) {
        payload.insights = insightsForCheatSheet;
      }
      //const body = JSON.stringify(this.insightsForCheatSheet || '');
      const body = JSON.stringify(payload);
      console.log('body', body);
      if (body) {
        try {
          addLoader('save');
          //const r = await fetch('http://localhost:8003/lp/cDAD-249', { method: 'PUT', body });
          const r = await fetch(`${ lpServer }/lp/${ l }`, { method: 'PUT', body });
          // const { token, lp, owner } = await r.json();
          const { token, lp } = await r.json();
          //todo: move this to the store
          console.log('save', lp, token);
          if (lp) {
            this.lp = lp;
            //$cookie.set('lp', lp);
            const { lps } = this;
            if (!lps) {
              this.lps = [lp];
            } else if (!lps.includes(lp)) {
              lps.push(lp);
              this.lps = lps;
            }
            // (async () => {
            //   const { $localforage: lf } = this;
            //   const lps = (await lf.getItem('lps')) || [];
            //   if (!lps.includes(lp)) {
            //     lps.push(lp);
            //   }
            //   await lf.setItem('lps', lps);
            // })();
          } else {
            console.log('save no lp');
            console.log('saved', l, lp);
          }
          if (token) {
            this.token = token;
            $cookie.set('token', token);
          } else {
            console.log('save no token');
          }
        } catch (ex) {
          console.log('save, failed', ex);
        } finally {
          removeLoader();
        }
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
//@import '../../scss/cheatsheet.scss';
.cheatsheet-controls {
  display: flex;
}
</style>
